import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
export function addAlert(alert, type = 'danger', options) {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `alerts.${alert}.${type}.title`,
      options: options
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `alerts.${alert}.${type}.message`,
      options: options
    }),
    type
  });
}